<!-- 若Group數量達到數量limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.groupLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p>{{groupContentStr | translate}}</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="OK" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 若Device數量達到數量limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.mapLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p>{{floorMapContentStr | translate}}</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="OK" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 若email數量達到數量limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.mailLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p>{{alertMailContentStr | translate}}</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="OK" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RCC 成功-->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.RCC_ResultSuccess" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 translate>Your device is now successfully connected to the Internet. </h5>
      <p *ngIf="!powerMaster" translate>Tap Confirm to start to experience PowerPanel Cloud.</p>
      <p *ngIf="powerMaster" translate>Tap Confirm to start to experience Cloud.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="Confirm" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RCC 再次確認-->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.RCC_ResultDoubleCheck" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 *ngIf="!powerMaster && !dialogType.RCC_AddDeviceType" translate>Please make sure Remote Cloud Card connects to the device.</h5>
      <h5 *ngIf="!powerMaster && dialogType.RCC_AddDeviceType" translate>Please make sure Cloud UPS connects to the device.</h5>
      <h5 *ngIf="powerMaster" translate>Please make sure CMCARD-E connects to the device.</h5>
      <p translate>You may edit device name in Device Settings.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RCC 輸入的MAC原本已存在server-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.RCC_ResultExist" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>The device already exists.</h5>
      <p translate>Please confirm your MAC number.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RCC 此MAC不存在，請重新確認-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.RCC_ResultNotExist" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>MAC does not exist.</h5>
      <p translate>Please confirm your MAC number.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="Confirm" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- RWCC 沒有WiFi-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.RWCC_NoWifi" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>No WiFi available.</h5>
      <p translate>Please make sure your computer's WiFi is on.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Card 新增失敗-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.RWCC_ConnectedFailed" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>Setup is failed.</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('ConnectedFail');" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RWCC 新增設備時，輸入Wifi密碼失敗-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.RWCC_WifiPwdError" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>WiFi setup failed. Please confirm password or select others. Make sure your computer is normally connected to Internet.</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RWCC 新增設備時，無連回Internet-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.RWCC_ConnectedNoInternet" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>Please make sure your computer is connected to the network.</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('NoInternet');" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RWCC 成功連上device-->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.RWCC_Connected" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 *ngIf="!powerMaster" translate>Your computer is connected to your Remote Wireless Cloud Card.</h5>
      <h5 *ngIf="powerMaster" translate>Your computer is connected to your CMCARD-W.</h5>
      <p translate>Tap Confirm to scan for nearby WiFi networks.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('ConnectedSuccess');" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- RWCC 成功-->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.RWCC_ResultSuccess" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 translate>Your device is now successfully connected to the Internet. </h5>
      <p *ngIf="!powerMaster" translate>Tap Confirm to start to experience PowerPanel Cloud.</p>
      <p *ngIf="powerMaster" translate>Tap Confirm to start to experience Cloud.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('redirectToIndex');" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 若Global map數量達到數量limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.globalMapLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p>{{globalMapContentStr | translate}}</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="OK" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Activate Plan Key 成功-->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.activatePlanKey_Success" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 translate>Key is successfully confirmed.</h5>
      <p translate>Tap Confirm to select your plan.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('KeySuccess')" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Activate Plan Key 失敗-->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.activatePlanKey_Failure" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>Key is not correct.</h5>
      <p translate>Please make sure your Internet connectivity is normal and key is correct.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('KeyFailure');" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 不符合trial / trial過期 / 超出plan node limit -->
<p-dialog header="{{'Locked' | translate}}" [(visible)]="dialogType.isExpired" [modal]="true" [resizable]="false" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="trialDialog">
  <div class="dialog-content trial-content">
    <blockquote class="blockquote text-center">
      <h1><i class="fa fa-lock"></i></h1>
      <p translate>You are seeing this because of below possible reasons:</p>
    </blockquote>
    <!-- <div class="note">
      <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i></strong>
      {{'Please download PowerPanel app from iOS/Android Platform, and use in-app purchase to get Plan after trial expires.' | translate}}
    </div> -->
    <div class="content-info">
      <ol>
        <li><strong translate>Trial_Locked_Reason1_1</strong><span translate>Trial_Locked_Reason1_2</span> <span class="badge critical" translate>Trial_Locked_Reason1_3</span> <span translate>Trial_Locked_Reason1_4</span></li>
        <li><strong translate>Trial_Locked_Reason2_1</strong><span translate>Trial_Locked_Reason2_2</span></li>
      </ol>
    </div>
    <div *ngIf="false else price"></div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="purchaseRouter()" label="{{'Buy Now' | translate}}" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 符合trial的設備 -->
<p-dialog header="{{'Free Trial' | translate}}" [(visible)]="dialogType.isTrialLicense" [modal]="true" [resizable]="false" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="trialDialog">
  <div class="dialog-content trial-content">
    <blockquote class="blockquote text-center">
      <h1>{{trialRemainingDays}}<small translate>days</small></h1>
      <p>{{ 'This device is eligible for {days}-day free trial' | translate: {days: trialRemainingDays} }}</p>
      <button type="button" pButton (click)="enableFreeTrial()" label="{{'Get Free Trial' | translate}}" class="{{Confirm_button}}"></button>
    </blockquote>
    <div class="note">
      <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i></strong>
      {{'Please download PowerPanel app from iOS/Android Platform, and use in-app purchase to get Plan after trial expires.' | translate}}
    </div>
    <div *ngIf="false else price"></div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="purchaseRouter()" label="{{'Buy Now' | translate}}" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 確認Locked是否超過可新增筆數 -->
<p-dialog header="{{'Locked' | translate}}" [(visible)]="dialogType.isLocked" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info" *ngIf="canAdd else canNotAdd">
      <h5 translate>Would you like to add this device to the plan to enable monitoring?</h5>
    </div>
    <ng-template #canNotAdd>
      <div class="content-info">
        <h5 translate>Please add your device to the plan in the Plan Settings to enable monitoring.</h5>
      </div>
    </ng-template>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();addDeviceToPlan();" class="{{Confirm_button}}" *ngIf="canAdd"></button>
    <button type="button" pButton label="{{'Go to Plan Settings' | translate}}" (click)="planSettingRouter();" class="{{Confirm_button}}" *ngIf="!canAdd"></button>
    <button type="button" pButton label="{{'Later' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- 確認AddToCloud是否超過可新增筆數 -->
<p-dialog header="{{'Add To Cloud' | translate}}" [(visible)]="dialogType.isAddToCloud" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info" *ngIf="addToCloudTab == 0">
      <p translate>The devices have already been added to the cloud and activated.</p>
    </div>
    <div class="content-info" *ngIf="addToCloudTab == 1">
      <p translate>The devices have already been added to the cloud. Please add your device to the plan in Plan Settings to monitor it.</p>
    </div>
    <div class="content-info" *ngIf="addToCloudTab == 2">
      <p translate>The devices have already been added to the cloud. To monitor them, please click "Buy Now" to obtain a valid plan. Alternatively, you can start with a trial by clicking the "Get Free Trial" button located on the device in the Dashboard.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Go to Plan Settings' | translate}}" (click)="planSettingRouter();closeDialog();" class="{{Confirm_button}}" *ngIf="addToCloudTab == 1"></button>
    <button type="button" pButton label="{{'Buy Now' | translate}}" (click)="purchaseRouter();closeDialog();" class="{{Confirm_button}}" *ngIf="addToCloudTab == 2"></button>
    <button type="button" pButton label="{{'Go to Dashboard' | translate}}" (click)="dashboardRouter();closeDialog();" class="{{Confirm_button}}" *ngIf="addToCloudTab == 0 || addToCloudTab == 2"></button>
    <button type="button" pButton label="{{'Later' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- 帳號無share device權限 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.ShareDeviceAlert" [modal]="true" [resizable]="false" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="trialDialog">
  <div class="dialog-content trial-content">
    <blockquote class="blockquote text-center">
      <h1><i class="fa fa-lock"></i></h1>
      <p translate>Share Device / Group is not available</p>
    </blockquote>
    <div class="note">
      <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i></strong>
      {{'Please upgrade to Level 50N to activate this feature.' | translate}}
    </div>
    <div *ngIf="false else price"></div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="purchaseRouter()" label="{{'Buy Now' | translate}}" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 設備無share device權限 (Trial) -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.ShareTrialDeviceAlert" [modal]="true" [resizable]="false" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="trialDialog">
  <div class="dialog-content trial-content">
    <blockquote class="blockquote text-center">
      <h1><i class="fa fa-lock"></i></h1>
      <p translate>This device is using trial license</p>
    </blockquote>
    <div class="note">
      <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i></strong>
      {{'Please go to Plan Settings to activate this device' | translate}}
    </div>
    <div *ngIf="false else price"></div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="purchaseRouter()" label="{{'Buy Now' | translate}}" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 設備無share device權限 (Expired) -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.ShareExpiredDeviceAlert" [modal]="true" [resizable]="false" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="trialDialog">
  <div class="dialog-content trial-content">
    <blockquote class="blockquote text-center">
      <h1><i class="fa fa-lock"></i></h1>
      <p translate>Share Device is not available</p>
    </blockquote>
    <div class="note">
      <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i></strong>
      {{'Please go to Plan Settings to activate this device' | translate}}
    </div>
    <div *ngIf="false else price"></div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="purchaseRouter()" label="{{'Buy Now' | translate}}" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- filter month limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.filterMonthLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p translate>The maximum filter range is 12-month. Please revise.</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="OK" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<ng-template #price>
  <ul class="list-group">
    <li class="list-group-item">
      <p>{{shareModel.price.level_1N.name}}: Node 1</p>
      <h5>${{shareModel.price.level_1N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
    <li class="list-group-item">
      <p>{{shareModel.price.level_3N.name}}: Node 3</p>
      <h5>${{shareModel.price.level_3N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
    <li class="list-group-item">
      <p>{{shareModel.price.level_10N.name}}: Node 10</p>
      <h5>${{shareModel.price.level_10N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
    <li class="list-group-item">
      <p>{{shareModel.price.level_20N.name}}: Node 20</p>
      <h5>${{shareModel.price.level_20N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
    <li class="list-group-item">
      <p>{{shareModel.price.level_50N.name}}: Node 50</p>
      <h5>${{shareModel.price.level_50N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
    <li class="list-group-item">
      <p>{{shareModel.price.level_100N.name}}: Node 100</p>
      <h5>${{shareModel.price.level_100N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
    <li class="list-group-item">
      <p>{{shareModel.price.level_200N.name}}: Node 200</p>
      <h5>${{shareModel.price.level_200N.oneYearPrice}} <small>/<span translate>year</span></small></h5>
    </li>
  </ul>
</ng-template>

<!-- 電池資料重置警告 -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.BatResetAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5 translate>Your battery information will be reset.</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- FW重大更新 -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.FirmwareAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5 translate>Critical firmware update is recommended</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Update' | translate}}" (click)="updateFirmware();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Later' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- 若ShareDevice數量達到數量limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.ShareDeviceLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;">One device can be shared with up to 3 users</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="OK" (click)="closeDialog()" class="ui-button-danger"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- 若ShareGroup數量達到數量limit  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.ShareGroupLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;">One group can be shared with up to 3 users</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="OK" (click)="closeDialog()" class="ui-button-danger"></button>
    </div>
  </ng-template>
</p-dialog>


<!-- 若Share User Name重複  -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.ShareUserNameLimit" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;">You already shared with this account</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="OK" (click)="closeDialog()" class="ui-button-danger"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- account email change alert -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.AccountEmailAlertDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{'Do you really want to use accountEmail to receive the system notification Email?_1' | translate}} <span class="strong">{{accountEmail}}</span> {{'Do you really want to use accountEmail to receive the system notification Email?_2' | translate}}</p>
    </div>
  </div>

  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('updateAccountEmailConfirm');" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();connectChange('updateAccountEmailCancel');" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- account Mobile change alert -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.AccountMobileAlertDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{'Do you really want to use to receive the SMS?_1' | translate}} <span class="strong">(+{{accountCountryCodes}}) {{accountMobile}}</span> {{'Do you really want to use to receive the SMS?_2' | translate}}</p>
      <div class="form-group check">
        <p-checkbox [(ngModel)]="mobileConfirmFlag" inputId="mobileConfirmCheck" [binary]="true"></p-checkbox><label for="mobileConfirmCheck">{{'I agree to receive SMS from PowerPanel Cloud' | translate}}</label>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('confrimMobileSMSCode');countdown.restart();" class="{{Confirm_button}}" [disabled]="!mobileConfirmFlag"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();connectChange('updateAccountMobileCancel');" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- 2-Factor Auth - Activation Flow: system問user是否要enable -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.TwoFactorAuthEnableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Do you really want to enable two-factor authentication when logging to both PowerPanel App and Website?</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('enableTwoFactorConfirm');countdown.restart();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();connectChange('enableTwoFactorCancel');" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- 2-Factor Auth - Activation Flow: system問user是否要disable -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.TwoFactorAuthDisableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Do you really want to disable two-factor authentication?</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('disableTwoFactorConfirm');countdown.restart();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();connectChange('disableTwoFactorCancel');" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system跳視窗請user輸入OTP -->
<p-dialog header="{{'Two-Factor Authentication' | translate}}" [(visible)]="dialogType.TwoFactorAuthDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="true">
  <div class="dialog-content">
    <div class="content-info center auth">
      <span class="fa-stack fa-lg">
        <span class="material-icons fa-stack-2x shield">
          shield
        </span>
        <span class="material-icons fa-stack-1x key">
          key
        </span>
      </span>
      <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
      <p-inputMask mask="999999" [(ngModel)]="OTPNumber" [ngClass]="{'ng-validDirty': dialogSaveDirty}" [disabled]="OTPOvertime" (keyup.enter)="OTPkeyupEnter($event);" (ngModelChange)="OTPNumberOnchange($event)"></p-inputMask>
      <p [ngClass]="{'message-error': OTPOvertime}">
        <span *ngIf="OTPOvertime else OTPOvertimeTrue">{{errorMsg | translate}} <br><span *ngIf="errorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
        <span class="time">
          <countdown #countdown [config]="config" (event)="handleEvent($event)"></countdown>
        </span>
      </p>
      <ng-template #OTPOvertimeTrue>
        <p style="color:red;font-weight: bolder;">{{errorMsg | translate}}</p>
        <p translate>OTP will expire in</p>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('confrimOTPnumber');" class="{{Confirm_button}}" *ngIf="!OTPOvertime" [disabled]="OTPNumberSubmitDisabled"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="OTPOvertime"></button>
  </ng-template>
</p-dialog>

<!-- OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.OTPLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- system問user是否要綁定 -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.SocialCombineEnableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{'Do you really want to combine socialType account_1' | translate}} <span class="capitalize strong">{{socialType}}</span> {{'Do you really want to combine socialType account_2' | translate}}</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange(socialType +'_Combine');" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system問user是否取消要綁定 -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.SocialCombineDisableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{'Do you really want to cancel the combination of socialType account_1' | translate}} <span class="capitalize strong">{{socialType}}</span> {{'Do you really want to cancel the combination of socialType account_2' | translate}}</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange(socialType +'_Cancel');" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system提醒user一次只能綁定一個社交帳號 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.SocialCombineOnlyOneAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>You can only combine up to 1 social account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- social account 重複綁定 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.SocialCombineAccountAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>This social account has already been combined with another PowerPanel Cloud account.</h5>
      <p translate>Please cancel the combination first if you want to combine this social account with the current PowerPanel Cloud account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- social account 解除綁定：仍為預設密碼且為最後一個 OAuth -->
<p-dialog header="{{'Password Setup Required' | translate}}" [(visible)]="dialogType.SocialCombineNoPasswordAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{ 'Before disconnecting your social account password setup_1' | translate }}<span class="capitalize strong">{{socialType}}</span>{{ 'Before disconnecting your social account password setup_2' | translate }}</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Go to Password Setup' | translate}}" (click)="closeDialog();connectChange(socialType + '_PasswordSetup');" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>


<!-- social account 出現同一個帳號底下的PPC & AFG e-mail 供user勾選要用哪個e-mail接收system notification -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.SocialCombineEmailDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="content-info">
      <p translate>Which e-mail address would you prefer to receive PowerPanel Cloud system notification?</p>
      <div class="email">
        <div class="list" (click)="cps.select()" [ngClass]="{'active': systemNotificationEmail == 'cps'}">
          <div class="emailLabel">
            <p-radioButton name="socialEmail" value="cps" inputId="socialEmailCps" [(ngModel)]="systemNotificationEmail" #cps></p-radioButton><label for="socialEmailCps">{{'My PowerPanel Cloud account e-mail' | translate}}</label>
          </div>
          <span class="name">{{PPCEmail}}</span>
        </div>
        <div class="list" (click)="social.select()" [ngClass]="{'active': systemNotificationEmail == 'social'}">
          <div class="emailLabel">
            <p-radioButton name="socialEmail" value="social" inputId="socialEmailSocial" [(ngModel)]="systemNotificationEmail" #social></p-radioButton><label for="socialEmailSocial">{{'My social account e-mail' | translate}}</label>
          </div>
          <span class="name">{{PlatformEmail}}</span>
        </div>
      </div>
      <small class="note">
        <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i></strong>
        {{'You can also edit the receiving e-mail in Account anytime in the future.' | translate}}
      </small>
    </div>

  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();chooseAccountEmail(1);" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();chooseAccountEmail(0);" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Purchase Attention -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="dialogType.PurchaseAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5 translate>Please read below reminder before you purchase.</h5>
      <ol>
        <li translate>Purchase basis is per account instead of device</li>
        <li translate>For example, if you purchase Level 20N, which is $309.99, you can access up to 20 UPS from your PowerPanel Cloud account.</li>
        <li><strong>{{'PPC can only be applied to one single plan at a time' | translate}}</strong></li>
      </ol>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'OK, I understand' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- Companion Flow: system問user是否要enable -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.CompanionEnableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Do you really want to enable PPC Companion?</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('enableCompanionConfirm');countdown.restart();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();connectChange('enableCompanionCancel');" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Companion Flow: system問user是否要disable -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.CompanionDisableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Do you really want to disable PPC Companion?</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('disableCompanionConfirm');countdown.restart();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();connectChange('disableCompanionCancel');" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system跳視窗請user輸入Companion Code -->
<p-dialog header="{{'PPC Companion Code'}}" [(visible)]="dialogType.CompanionCodeDialogType" [closable]="!closeCompanionConfirmOTP"  [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="setupDialog ConfirmDialog setup">
  <div class="dialog-content flex-start">
    <div class="dialog-content">
      <div class="content-info center auth">
        <span class="fa-stack fa-lg">
          <span class="material-icons fa-stack-2x shield">
            shield
          </span>
          <span class="material-icons fa-stack-1x key">
            key
          </span>
        </span>
        <h5>
          <span translate>Please enter Companion Code shown in</span>
          <span *ngIf="selectDefaultReceive == 'SMS'"> SMS </span>
          <span *ngIf="selectDefaultReceive == 'PowerPanelCloudApp'"> {{'PowerPanel Cloud App' | translate}} </span>
        </h5>
        <p-inputMask mask="999999" [(ngModel)]="CompanionCode" [ngClass]="{'ng-validDirty': CompanionCodedialogSaveDirty}" [disabled]="CompanionCodeOvertime" (keyup.enter)="CompanionCodekeyupEnter($event);" (ngModelChange)="CompanionCodeOnchange($event)"></p-inputMask>
        <p [ngClass]="{'message-error': CompanionCodeOvertime}">
          <span *ngIf="CompanionCodeOvertime else CompanionCodeOvertimeTrue">{{errorMsgCompanionCode | translate}} <br><span *ngIf="companionerrorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
          <span class="time">
            <countdown #countdownCompanion [config]="config" (event)="handleEventCompanionCode(companionCodeAuthType, $event)"></countdown>
          </span>
        </p>
        <ng-template #CompanionCodeOvertimeTrue>
          <p style="color:red;font-weight: bolder;">{{errorMsgCompanionCode | translate}}</p>
          <p translate>Companion Code will expire in</p>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div *ngIf="companionCodeAuthType === 'enableCompanionConfirm'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('enableCompanion');" class="{{Confirm_button}}" *ngIf="!CompanionCodeOvertime" [disabled]="CompanionCodeSubmitDisabled"></button>
    </div>
    <div *ngIf="companionCodeAuthType === 'disableCompanionConfirm'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('disableCompanion');" class="{{Confirm_button}}" *ngIf="!CompanionCodeOvertime" [disabled]="CompanionCodeSubmitDisabled"></button>
    </div>
    <div *ngIf="companionCodeAuthType === 'ResendCode'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('ResendCode');" class="{{Confirm_button}}" *ngIf="!CompanionCodeOvertime" [disabled]="CompanionCodeSubmitDisabled"></button>
      <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();connectChange('Reload_Companion');" class="{{Confirm_button}}" *ngIf="closeCompanionConfirmOTP else closeCompanionOTPdailog"></button>
    </div>
    <div *ngIf="companionCodeAuthType === 'ConfirmCompanionEvent'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('Confirm_CompanionEvent');" class="{{Confirm_button}}" *ngIf="!CompanionCodeOvertime" [disabled]="CompanionCodeSubmitDisabled"></button>
      <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();connectChange('closeCompanionOTPdailog');" class="{{Confirm_button}}"></button>
    </div>
    <ng-template #closeCompanionOTPdailog>
      <div>
        <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="CompanionCodeOvertime"></button>
      </div>
    </ng-template>
    <!-- <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="CompanionCodeOvertime"></button> -->
  </ng-template>
</p-dialog>

<!-- Companion Code system跳錯誤訊息:*帳號鎖住3分鐘後才能重送Companion Code -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.CompanionCodeLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The companion code is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- Mobile Verification -->
<p-dialog header="{{'Mobile Verification' | translate}}" [(visible)]="dialogType.MobileVerificationDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="true">
  <div class="dialog-content">
    <div class="content-info center auth">
      <span class="fa-stack fa-lg">
        <span class="material-icons fa-stack-2x shield">
          shield
        </span>
        <span class="material-icons fa-stack-1x key">
          key
        </span>
      </span>
      <h5 translate>Please enter OTP received from SMS</h5>
      <p-inputMask mask="999999" [(ngModel)]="MobileSMSCode" [ngClass]="{'ng-validDirty': MobileSMSCodedialogSaveDirty}" [disabled]="MobileSMSCodeOvertime" (keyup.enter)="MobileSMSCodekeyupEnter($event);" (ngModelChange)="MobileSMSCodeOnchange($event)"></p-inputMask>
      <p [ngClass]="{'message-error': MobileSMSCodeOvertime}">
        <span *ngIf="MobileSMSCodeOvertime else MobileSMSCodeOverTrue">{{errorMsgMobileSMS | translate}} <br><span *ngIf="mobileErrorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
        <span class="time">
          <countdown #countdownMobileSMS [config]="config" (event)="handleMobileSMS($event)"></countdown>
        </span>
      </p>
      <ng-template #MobileSMSCodeOverTrue>
        <p style="color:red;font-weight: bolder;">{{errorMsgMobileSMS | translate}}</p>
        <p translate>OTP will expire in</p>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('updateAccountMobileConfirm');" class="{{Confirm_button}}" *ngIf="!MobileSMSCodeOvertime" [disabled]="MobileSMSCodeSubmitDisabled"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="MobileSMSCodeOvertime"></button>
  </ng-template>
</p-dialog>

<!-- Mobile SMS Code跳錯誤訊息:*帳號鎖住3分鐘後才能重送Mobile SMS Code -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.MobileSMSCodeLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The mobile SMS code is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Mobile SMS 跳錯誤訊息:*帳號已達10次之今日上限 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.MobileSMSLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>You have reached the attempt limit. This function will be temporarily disabled within 24 hours.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- account Mobile Remove alert -->
<p-dialog header="{{'Delete Mobile Number' | translate}}" [(visible)]="dialogType.MobileRemoveAlertDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p>{{'Once you remove it, the option of receiving verification via SMS is not available anymore.' | translate}}</p>
    </div>
  </div>
  <div class="alert alert-warning" translate style="margin-top: 1em; margin-bottom: 0;" *ngIf="selectDefaultReceiveSMS">
    If you selected SMS as the method to receive companion code, you will have to switch to Main App before you delete this mobile number.
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('removeAccountMobileConfirm');" class="{{Confirm_button}}" [disabled]="selectDefaultReceiveSMS"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>
<!--Company Member List Dialog-->
<p-dialog header="{{'Company Member List'}}" class="scrollDialog" [(visible)]="dialogType.CompanyMemberListDialog" [modal]="true" [style]="{'width': '550px', 'min-width': '200px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="alert alert-danger" *ngIf="addMemberErrorMsgFlag" [ngClass]="{'alert-dismissible fade show': addMemberErrorMsgFlag}">
      <div><span class="padding-horizontal">{{addMemberErrorMsg | translate}}</span></div>
      <button type="button" class="close" (click)="closeAddMemberErrorMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-group">
      <label translate>User Name</label>
      <div class="flex align-items-none">
        <input type="email" class="form-control pInputText" pInputText placeholder="Account" [(ngModel)]="memberEmailInput" pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" #revAddMemberEmail="ngModel" (ngModelChange)="memberEmailOnchange()">
        <button pButton icon="fa fa-plus" [disabled]="revAddMemberEmail.invalid || memberEmailInput === '' || addCompanyMemberFlag" (click)="connectChange('addCompanyMember');"></button>
      </div>
    </div>
    <!-- <div class="form-group" style="margin-bottom: 0 !important;">
      <div class="flex margin-none">
        <label><span translate>Member</span> ({{companyMemberList.length}}) </label>
        <button pButton type="button" label="{{'Import' | translate}}" icon="pi pi-upload" class="btn-link" (click)="importCompanyMemberDialog()"></button>
      </div>
    </div> -->
    <div class="form-group" style="margin-bottom: 0 !important;">
      <label><span translate>Member</span> ({{companyMemberList.length}}) </label>
    </div>
    <p-table class="recipientTable member" [value]="companyMemberList" [paginator]="false" [rows]="10" [scrollable]="true" scrollHeight="288px">
      <ng-template #caption>
          <div class="header-company">{{ selectCompanyName }}</div>
      </ng-template>
      <ng-template #header>
        <tr>
            <th></th>
            <th style="width:50px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
        <tr [pSelectableRow]="rowData">
          <td class="col-nowrap">
            <div class="recipient">
              <div class="icon">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa-stack-1x name">{{rowData.account.substr(0,1)}}</i>
                </span>
              </div>
              <div class="data">
                <h5 style="margin: 0;">{{rowData.account}}</h5>
              </div>
            </div>
          </td>
          <td class="col-btn text-center" style="width:50px">
            <!-- <button pButton icon="fa fa-trash" (click)="showDeleteMemberConfirmDialog(i)"></button> -->
            <button pButton icon="fa fa-trash" (click)="deleteMember(i,rowData)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2">
            <div translate class="ui-emptymessage">No Data found</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template #footer>
    <!-- <button type="button" pButton label="{{'Import' | translate}}" class="{{Confirm_button}} delete"></button> -->
    <button type="button" pButton label="{{'Save' | translate}}" (click)="connectChange('saveCompanyMember');" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- 確認是否刪除已被設定為Admin的Member -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.CheckDeleteAdminMemberDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p><span class="strong">{{checkDeleteAdminMemberName}}</span><span translate> is an Admin Account of </span><span class="strong">{{checkDeleteAdminMemberCompany}}</span>. <span translate>If you delete its Member, the Admin permissions will also be deleted.Are you sure to?</span></p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeCheckDeleteAdminMemberDialog();" class="p-button-secondary"></button>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeCheckDeleteAdminMemberDialog();confirmDeleteMember();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Import Dialog -->
<p-dialog header="{{'Import' | translate }}" [(visible)]="dialogType.ImportCompanyMemberDialog" [modal]="true" [style]="{'width': '450px', 'min-width': '200px'}" class="updateDialog" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="alert alert-danger" *ngIf="importMemberErrorMsg" [ngClass]="{'alert-dismissible fade show': importMemberErrorMsg}">
      <div>Some members might not be added successfully. Only accounts with the same email domain and country as the main account can be added.</div>
      <button type="button" class="close" (click)="closeImportMemberErrorMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-group file">
      <label>{{'File' | translate }}</label>
      <input type='file' #file_upload
             accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
             class="form-control pInputText" (change)="handleFileInput($event)" [(ngModel)]="importMemberFlie">
    </div>
    <div class="alert alert-warning" translate>
      Notice : This feature is only allowed to import when the format and content is correct.
    </div>
  </div>
  <ng-template #footer>
    <button type="button" [disabled]="!fileUploaded || importMemberFlie.length === 0" pButton label="{{'Import' | translate }}" (click)="connectChange('ImportCompanyMember');" class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="closeImportCompanyMemberDialog()" label="{{'Cancel' | translate }}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Agree APIs Terms沒有勾選 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.apiAgreeAPITermsAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please read and check the Terms of Use to enable this feature.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- API 未開啟2FA顯示 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.apiTwoFactorEnableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>To use the API, please enable 2-Factor Authentication.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- API system跳視窗請user輸入OTP -->
<p-dialog header="{{'API Two-Factor Authentication' | translate}}" [(visible)]="dialogType.APITwoFactorAuthDialog" [closable]="!closeAPIConfirmOTP"  [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="ConfirmDialog setup">
  <div class="dialog-content flex-start">
    <div class="dialog-content">
      <div class="content-info center auth">
        <span class="fa-stack fa-lg">
          <span class="material-icons fa-stack-2x shield">
            shield
          </span>
          <span class="material-icons fa-stack-1x key">
            key
          </span>
        </span>
        <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
        <p-inputMask mask="999999" [(ngModel)]="APICode" [ngClass]="{'ng-validDirty': APICodedialogSaveDirty}" [disabled]="APICodeOvertime" (keyup.enter)="APICodekeyupEnter($event);" (ngModelChange)="APICodeOnchange($event)"></p-inputMask>
        <p [ngClass]="{'message-error': APICodeOvertime}">
          <span *ngIf="APICodeOvertime else APICodeOvertimeTrue">{{errorMsgAPICode | translate}} <br><span *ngIf="APIerrorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
          <span class="time">
            <countdown #countdownAPI [config]="config" (event)="handleAPICode(APICodeAuthType, $event)"></countdown>
          </span>
        </p>
        <ng-template #APICodeOvertimeTrue>
          <p style="color:red;font-weight: bolder;">{{errorMsgAPICode | translate}}</p>
          <p translate>OTP will expire in</p>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div *ngIf="APICodeAuthType === 'enableAPIAccess'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('enableAPIAccess');" class="{{Confirm_button}}" *ngIf="!APICodeOvertime" [disabled]="APICodeSubmitDisabled"></button>
    </div>
    <div *ngIf="APICodeAuthType === 'disableAPIAccess'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('disableAPIAccess');" class="{{Confirm_button}}" *ngIf="!APICodeOvertime" [disabled]="APICodeSubmitDisabled"></button>
    </div>
    <div *ngIf="APICodeAuthType === 'enableAPIKey'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('enableAPIKey');" class="{{Confirm_button}}" *ngIf="!APICodeOvertime" [disabled]="APICodeSubmitDisabled"></button>
    </div>
    <div *ngIf="APICodeAuthType === 'disableAPIKey'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('disableAPIKey');" class="{{Confirm_button}}" *ngIf="!APICodeOvertime" [disabled]="APICodeSubmitDisabled"></button>
    </div>
    <div *ngIf="APICodeAuthType === 'addAPIKey'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('addAPIKey');" class="{{Confirm_button}}" *ngIf="!APICodeOvertime" [disabled]="APICodeSubmitDisabled"></button>
    </div>
    <div *ngIf="APICodeAuthType === 'deleteAPIKey'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('deleteAPIKey');" class="{{Confirm_button}}" *ngIf="!APICodeOvertime" [disabled]="APICodeSubmitDisabled"></button>
    </div>
    <div>
      <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="APICodeOvertime"></button>
    </div>
  </ng-template>
</p-dialog>

<!--API OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.APICodeLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!--API Create Dialog-->
<p-dialog header="{{'API Create'}}" [(visible)]="dialogType.apiCreateDialog" [modal]="true" [style]="{'width': '550px', 'min-width': '200px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group" style="margin: 0 !important">
      <label translate>The Key is ready for use in few minutes</label>
      <label translate>The Key is not stored. Copy the key and save it in safe place</label>
      <div class="ui-inputgroup width100">
        <input type="text" pInputText placeholder="Keyword" [(ngModel)]="apikey" [disabled]="true" id="InputApiId">
        <button pButton type="button" label="Copy" (click)="copyApiKeyText()"></button>
    </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Plan Setting 從Level 2 + 以上 downgrade，按Save時 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.apiPlanSettingDowngradeAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>If you choose a plan that is lower than Level 50N, you will not be able to use the API function. Please confirm if you would like to continue.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();connectChange('planDowngradeAPIEableConfirm');" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system跳視窗請user輸入UpgradeGatewayOTP -->
<p-dialog header="{{'Upgrade Gateway' | translate}}" [(visible)]="dialogType.UpgradeGatewayDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="true">
  <div class="dialog-content">
    <div class="content-info center auth">
      <span class="fa-stack fa-lg">
        <span class="material-icons fa-stack-2x shield">
          shield
        </span>
        <span class="material-icons fa-stack-1x key">
          key
        </span>
      </span>
      <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
      <p-inputMask mask="999999" [(ngModel)]="UpgradeGatewayCode" [ngClass]="{'ng-validDirty': UpgradeGatewaydialogSaveDirty}" [disabled]="UpgradeGatewayOvertime" (keyup.enter)="UpgradeGatewayCodekeyupEnter($event);" (ngModelChange)="UpgradeGatewayCodeOnchange($event)"></p-inputMask>
      <p [ngClass]="{'message-error': UpgradeGatewayOvertime}">
        <span *ngIf="UpgradeGatewayOvertime else UpgradeGatewayOvertimeTrue">{{errorMsgUpgradeGatewayCode | translate}} <br><span *ngIf="UpgradeGatewayErrorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
        <span class="time">
          <countdown #counterGateway [config]="config" (event)="handleEvent($event)"></countdown>
        </span>
      </p>
      <ng-template #UpgradeGatewayOvertimeTrue>
        <p style="color:red;font-weight: bolder;">{{errorMsgUpgradeGatewayCode | translate}}</p>
        <p translate>OTP will expire in</p>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Submit' | translate}}" (click)="UpgradeGatewayCodekeyupEnter($event);" class="{{Confirm_button}}" *ngIf="!UpgradeGatewayOvertime" [disabled]="UpgradeGatewaySubmitDisabled"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="UpgradeGatewayOvertime"></button>
  </ng-template>
</p-dialog>

<!-- OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.UpgradeGatewayLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 提示使用者記得要加入Pro Hierarchy -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="dialogType.addToHierarchyWarning" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please add the company to the hierarchy before adding the member.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Delete Confirm -->
<!-- <p-dialog header="Confirm" [(visible)]="dialogType.confirmDeleteMember" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="connectChange('DeleteCompanyMember');"></button>
      <button type="button" pButton (click)="dialogType.confirmDeleteMember=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog> -->


<!-- Agree Ups Control沒有勾選 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.agreeUpsControlAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please read and check the agreement to enable this feature.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Ups Control 未開啟2FA顯示 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.upsControlTwoFactorEnableAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>To enable UPS Control feature, please enable 2-Factor Authentication.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Later' | translate }}" (click)="closeDialog()" class="p-button-secondary"></button>
    <button type="button" pButton label="{{'2-FA Settings' | translate}}" (click)="closeDialog();redirect('/account-info')" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- UPS Control system跳視窗請user輸入OTP -->
<p-dialog header="{{'UPS Control Two-Factor Authentication' | translate}}" [(visible)]="dialogType.upsControlTwoFactorAuthDialog" [closable]="!closeUpsControlConfirmOTP"  [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" class="ConfirmDialog setup">
  <div class="dialog-content flex-start">
    <div class="dialog-content">
      <div class="content-info center auth">
        <span class="fa-stack fa-lg">
          <span class="material-icons fa-stack-2x shield">
            shield
          </span>
          <span class="material-icons fa-stack-1x key">
            key
          </span>
        </span>
        <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
        <p-inputMask mask="999999" [(ngModel)]="upsControlCode" [ngClass]="{'ng-validDirty': upsControlCodedialogSaveDirty}" [disabled]="upsControlCodeOvertime" (keyup.enter)="upsControlCodekeyupEnter($event);" (ngModelChange)="upsControlCodeOnchange($event)"></p-inputMask>
        <p-message severity="error" *ngIf="upsControlCodedialogSaveDirty"></p-message>
        <p [ngClass]="{'message-error': upsControlCodeOvertime}">
          <span *ngIf="upsControlCodeOvertime else upsControlCodeOvertimeTrue">{{errorMsgupsControlCode | translate}} <br><span *ngIf="upsControlerrorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
          <span class="time">
            <countdown #countdownUpsControl [config]="config" (event)="handleUpsControlCode(upsControlCodeAuthType, $event)"></countdown>
          </span>
        </p>
        <ng-template #upsControlCodeOvertimeTrue>
          <p style="color:red;font-weight: bolder;">{{errorMsgupsControlCode | translate}}</p>
          <p translate>OTP will expire in</p>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div *ngIf="upsControlCodeAuthType === 'enableUpsControlAccess'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('enableUpsControlAccess');" class="{{Confirm_button}}" *ngIf="!upsControlCodeOvertime" [disabled]="upsControlCodeSubmitDisabled"></button>
    </div>
    <div *ngIf="upsControlCodeAuthType === 'disableUpsControlAccess'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('disableUpsControlAccess');" class="{{Confirm_button}}" *ngIf="!upsControlCodeOvertime" [disabled]="upsControlCodeSubmitDisabled"></button>
    </div>
    <div *ngIf="upsControlCodeAuthType === 'turnOn'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('turnOn');" class="{{Confirm_button}}" *ngIf="!upsControlCodeOvertime" [disabled]="upsControlCodeSubmitDisabled"></button>
    </div>
    <div *ngIf="upsControlCodeAuthType === 'turnOff'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('turnOff');" class="{{Confirm_button}}" *ngIf="!upsControlCodeOvertime" [disabled]="upsControlCodeSubmitDisabled"></button>
    </div>
    <div *ngIf="upsControlCodeAuthType === 'powerCycle'">
      <button type="button" pButton label="{{'Submit' | translate}}" (click)="connectChange('powerCycle');" class="{{Confirm_button}}" *ngIf="!upsControlCodeOvertime" [disabled]="upsControlCodeSubmitDisabled"></button>
    </div>
    <div>
      <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="upsControlCodeOvertime"></button>
    </div>
  </ng-template>
</p-dialog>

<!--UPS Control OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="dialogType.upsControlCodeLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- Cloud Control Disabled -->
<p-dialog header="{{'Cloud Control Disabled' | translate}}" [(visible)]="dialogType.cloudControlDisabledDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p translate>To use this feature, please ensure your UPS firmware supports cloud control and the "Cloud Ctrl" setting is enabled on the UPS local panel.</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Got it' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- Power Action Options Turn On -->
<p-dialog header="{{'Power Action Options' | translate}}" [(visible)]="dialogType.cloudControlTurnOnDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p translate>Are you sure you want to turn on this device?</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton icon="fa fa-power-off" label="{{'Turn On' | translate }}" (click)="this.dialogType.cloudControlTurnOffDialog = false;connectAddOtpChange('turnOn');" class="ui-button-normal"></button>
    <button type="button" pButton (click)="closeDialog()" label="{{'Cancel' | translate }}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>


<!-- Power Action Options Processing -->
<p-dialog  [(visible)]="dialogType.cloudControlProcessingDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog processing" [closable]="true">
  <div class="dialog-content">
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
      <p>{{'Processing' | translate}}...</p>
    </div>
    <p-progressBar mode="indeterminate" [style]="{'height': '6px','margin': '0 0 2.5em 0'}"></p-progressBar>
  </div>
</p-dialog>


<!-- Power Action Options Turn Off -->
<p-dialog header="{{'Power Action Options' | translate}}" [(visible)]="dialogType.cloudControlTurnOffDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <div class="content-info">
      <p translate>Do you want to power cycle the device or turn it off completely?</p>
      <div class="power">
        <div class="list" (click)="turnOff.select()" [ngClass]="{'active': powerActionOptions == 'turnOff'}">
          <div class="powerLabel">
            <div class="icon">
              <i class="fa fa-power-off" aria-hidden="true"></i>
            </div>
            <p-radiobutton name="powerOptions" value="turnOff" inputId="powerOptionTurnOff" [(ngModel)]="powerActionOptions" #turnOff></p-radiobutton><label for="powerOptionTurnOff" translate>Turn Off</label>
          </div>
        </div>
        <div class="list" (click)="powerCycle.select()" [ngClass]="{'active': powerActionOptions == 'powerCycle'}">
          <div class="powerLabel">
            <div class="icon">
              <i class="fa fa-refresh" aria-hidden="true"></i>
            </div>
            <p-radiobutton name="powerOptions" value="powerCycle" inputId="powerOptionPowerCycle" [(ngModel)]="powerActionOptions" #powerCycle></p-radiobutton><label for="powerOptionPowerCycle" translate>Power Cycle</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <ng-container *ngIf="powerActionOptions === ''">
      <button type="button" pButton label="{{'Confirm' | translate}}" [disabled]="powerActionOptions === ''" class="{{Confirm_button}}"></button> 
    </ng-container>
    <ng-container *ngIf="powerActionOptions !== ''">
      <button type="button" pButton label="{{'Confirm' | translate}}" *ngIf="powerActionOptions == 'turnOff'" (click)="this.dialogType.cloudControlTurnOnDialog = false;this.dialogType.cloudControlTurnOffDialog = false;connectAddOtpChange('turnOff');" class="{{Confirm_button}}"></button>
      <button type="button" pButton label="{{'Confirm' | translate}}" *ngIf="powerActionOptions == 'powerCycle'" (click)="this.dialogType.cloudControlTurnOnDialog = false;this.dialogType.cloudControlTurnOffDialog = false;connectAddOtpChange('powerCycle');" class="{{Confirm_button}}"></button>
    </ng-container>
    <button type="button" pButton (click)="closeDialog()" label="{{'Cancel' | translate }}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Power Action Options Success -->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.cloudControlResultSuccessDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-check-circle normal"></i>
    </div>
    <div class="content-info">
      <h5 translate>Success</h5>
      <p translate *ngIf="upsControlCodeAuthType === 'TurnOn'">The device has been successfully powered on.</p>
      <p translate *ngIf="upsControlCodeAuthType === 'TurnOff'">The device has been successfully powered off.</p>
      <p translate *ngIf="upsControlCodeAuthType === 'PowerCycle'">Power cycle completed successfully. The UPS has restarted.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Got it' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- Power Action Options Failed -->
<p-dialog header="{{'Information' | translate}}" [(visible)]="dialogType.cloudControlResultFailedDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>Action failed</h5>
      <p translate *ngIf="upsControlCodeAuthType === 'TurnOn'">Failed to turn on the device. Please check the network connection or device status and try again.</p>
      <p translate *ngIf="upsControlCodeAuthType === 'TurnOff'">Failed to turn off the device. Please check the network connection or device status and try again.</p>
      <p translate *ngIf="upsControlCodeAuthType === 'PowerCycle'">Failed to power cycle the device. Please check the network connection or device status and try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Got it' | translate}}" (click)="closeDialog()" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>



